import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';
export const BreadcrumbWrapper: StyleRule = () => ({
    marginTop: pxToRem(45),
    marginBottom: pxToRem(44),
});
